import type { ReactNode } from "react";

export function CardSkeleton({ rows = 3 }: { rows?: number }) {
  return <div className="animate-pulse space-y-3" aria-label="Loading">
    {Array.from({ length: rows }, (_, index) => <div key={index} className={`h-4 rounded bg-zinc-100 ${index === 0 ? "w-2/5" : "w-full"}`} />)}
  </div>;
}

export function CardError({ message, retry }: { message: string; retry: () => void }) {
  return <div className="grid min-h-24 place-items-center text-center">
    <div><p className="text-sm text-red-600">{message}</p><button type="button" onClick={retry} className="mt-2 text-sm font-medium text-indigo-500 hover:underline">Try again</button></div>
  </div>;
}

export function CardEmpty({ children = "No data for current filters." }: { children?: ReactNode }) {
  return <div className="grid min-h-24 place-items-center text-center text-sm text-zinc-500">{children}</div>;
}
